// packages/contract/fixtures/nyonya-table.ts
//
// HEALTHY. The prototype's restaurant. A client on the Growth plan, not gated.
// Exists to exercise the gap banner: strong on Google (#3 for its lead
// question), weak in AI answers (named in only 4 of 15). Three months of
// history, a populated feed.

import type { LatestSnapshot } from '../contract';

export const nyonyaTable: LatestSnapshot = {
  business: {
    id: 'nyonya-table',
    name: 'Nyonya Table',
    domain: 'nyonyatable.com',
    vertical: 'Peranakan restaurant',
    city: 'Bukit Bintang',
    state: 'client',
    plan: 'growth',
  },
  snapshot: {
    // The scan the Visibility fixture reads (nyonya-visibility.ts), so the
    // header, Fixes and Site all state the date Visibility does.
    id: 'snap-nyonya-2026-09',
    businessId: 'nyonya-table',
    capturedAt: '2026-09-16',
    gated: false,
    gateReasons: [],
    total: 58,
    level: 3,
    levelName: 'Getting there',
    plusMinus: 5,
    samplesPerCell: 3,
    previousTotal: 44,
    pillars: [
      { key: 'answer_presence', label: 'When people ask AI', kind: 'result', score: 14, max: 35, band: 'weak' },
      { key: 'search_rank', label: 'When people search Google', kind: 'result', score: 15, max: 20, band: 'good' },
      { key: 'site', label: 'Pages AI can read', kind: 'lever', score: 9, max: 15, band: 'getting_there' },
      { key: 'sources', label: 'Where AI hears about you', kind: 'lever', score: 10, max: 15, band: 'good' },
      { key: 'reputation', label: 'What your customers say', kind: 'lever', score: 10, max: 15, band: 'good' },
    ],
    headline: {
      questionsTested: 15,
      mentionsTotal: 46,
      namedRate: 0.27,
      linkRate: 0.12,
      bestGooglePosition: 3,
      sentiment: 0.62,
      sentimentSuppressed: false,
      plainSummary:
        'When people search Google for Peranakan food near you, you show up third. But when they ask an AI the same thing, you are named far less often. Closing that gap is where your next customers are.',
    },
    questions: [
      {
        id: 'q-ny-1', text: 'best Peranakan restaurant Bukit Bintang',
        engines: [
          { engine: 'chatgpt', samples: 3, hits: 1, position: 4 },
          { engine: 'gemini', samples: 3, hits: 0, position: null },
          { engine: 'claude', samples: 3, hits: 2, position: 3 },
          { engine: 'perplexity', samples: 3, hits: 3, position: 1 },
          { engine: 'ai_overview', samples: 3, hits: 1, position: 5 },
        ],
        googleOrganic: 3, localPack: 2, siteAnswers: true, actionId: null,
      },
      {
        id: 'q-ny-2', text: 'authentic laksa near me Bukit Bintang',
        engines: [
          { engine: 'chatgpt', samples: 3, hits: 3, position: 1 },
          { engine: 'gemini', samples: 3, hits: 2, position: 2 },
          { engine: 'claude', samples: 3, hits: 2, position: 2 },
          { engine: 'perplexity', samples: 3, hits: 3, position: 1 },
          { engine: 'ai_overview', samples: 3, hits: 1, position: 4 },
        ],
        googleOrganic: 1, localPack: 1, siteAnswers: true, actionId: null,
      },
      {
        id: 'q-ny-3', text: 'where to eat nyonya food Kuala Lumpur',
        engines: [
          { engine: 'chatgpt', samples: 3, hits: 1, position: 4 },
          { engine: 'gemini', samples: 3, hits: 1, position: 5 },
          { engine: 'claude', samples: 3, hits: 0, position: null },
          { engine: 'perplexity', samples: 3, hits: 1, position: 3 },
          { engine: 'ai_overview', samples: 3, hits: 0, position: null },
        ],
        googleOrganic: 6, localPack: null, siteAnswers: true, actionId: 'a-ny-2',
      },
      {
        id: 'q-ny-4', text: 'family friendly Peranakan restaurant',
        engines: [
          { engine: 'chatgpt', samples: 3, hits: 0, position: null },
          { engine: 'gemini', samples: 3, hits: 0, position: null },
          { engine: 'claude', samples: 3, hits: 0, position: null },
          { engine: 'perplexity', samples: 3, hits: 0, position: null },
          { engine: 'ai_overview', samples: 3, hits: 0, position: null },
        ],
        googleOrganic: 9, localPack: null, siteAnswers: false, actionId: 'a-ny-1',
      },
      {
        id: 'q-ny-5', text: 'date night restaurant Bukit Bintang',
        engines: [
          { engine: 'chatgpt', samples: 3, hits: 2, position: 3 },
          { engine: 'gemini', samples: 3, hits: 0, position: null },
          { engine: 'claude', samples: 3, hits: 0, position: null },
          { engine: 'perplexity', samples: 3, hits: 1, position: 6 },
          { engine: 'ai_overview', samples: 3, hits: 0, position: null },
        ],
        googleOrganic: 12, localPack: null, siteAnswers: false, actionId: 'a-ny-3',
      },
      {
        id: 'q-ny-6', text: 'best ayam buah keluak Kuala Lumpur',
        engines: [
          { engine: 'chatgpt', samples: 3, hits: 0, position: null },
          { engine: 'gemini', samples: 3, hits: 0, position: null },
          { engine: 'claude', samples: 3, hits: 1, position: 5 },
          { engine: 'perplexity', samples: 3, hits: 1, position: 4 },
          { engine: 'ai_overview', samples: 3, hits: 0, position: null },
        ],
        googleOrganic: 7, localPack: null, siteAnswers: true, actionId: 'a-ny-2',
      },
      {
        id: 'q-ny-7', text: 'halal Peranakan restaurant Kuala Lumpur',
        engines: [
          { engine: 'chatgpt', samples: 3, hits: 0, position: null },
          { engine: 'gemini', samples: 3, hits: 0, position: null },
          { engine: 'claude', samples: 3, hits: 0, position: null },
          { engine: 'perplexity', samples: 3, hits: 0, position: null },
          { engine: 'ai_overview', samples: 3, hits: 0, position: null },
        ],
        googleOrganic: null, localPack: null, siteAnswers: false, actionId: 'a-ny-1',
      },
      {
        id: 'q-ny-8', text: 'restaurant for large group Bukit Bintang',
        engines: [
          { engine: 'chatgpt', samples: 3, hits: 1, position: 6 },
          { engine: 'gemini', samples: 3, hits: 0, position: null },
          { engine: 'claude', samples: 3, hits: 0, position: null },
          { engine: 'perplexity', samples: 3, hits: 0, position: null },
          { engine: 'ai_overview', samples: 3, hits: 0, position: null },
        ],
        googleOrganic: 8, localPack: null, siteAnswers: false, actionId: 'a-ny-3',
      },
    ],
    rivals: [
      {
        name: "Baba's Kitchen", domain: 'babaskitchen.my',
        winsQuestionIds: ['q-ny-4', 'q-ny-3', 'q-ny-6'],
        whatTheyHave: 'A page titled "Family & group dining" that AI quotes for family questions. You have none.',
        reviewCount: 540, reviewRating: 4.7, total: 72, previousTotal: 69,
      },
      {
        name: 'Heritage Rasa', domain: 'heritagerasa.my',
        winsQuestionIds: ['q-ny-7'],
        whatTheyHave: 'Their menu page states clearly that dishes are halal. Yours does not say either way.',
        reviewCount: 410, reviewRating: 4.5, total: 64, previousTotal: 64,
      },
      {
        name: 'Kampung Spice', domain: 'kampungspice.sg',
        winsQuestionIds: ['q-ny-5'],
        whatTheyHave: 'A "private dining & celebrations" page AI brings up for date-night and occasion searches.',
        reviewCount: 280, reviewRating: 4.4, total: 51, previousTotal: 53,
      },
      {
        name: 'Peranakan Co.', domain: 'peranakanco.my',
        winsQuestionIds: [],
        whatTheyHave: 'Nothing you do not. You are ahead of them on every question we tested.',
        reviewCount: 190, reviewRating: 4.3, total: 40, previousTotal: 38,
      },
    ],
    setup: {
      site: [
        { label: 'Your menu is on your own website', status: 'ok', detail: 'Full menu with dish descriptions AI can read.' },
        { label: 'A page for family and group dining', status: 'missing', detail: 'People ask AI for this. You have no page for it.' },
        { label: 'Your menu says whether dishes are halal', status: 'missing', detail: 'A common question AI cannot answer for you.' },
        { label: 'Opening hours match across the web', status: 'ok' },
      ],
      sources: [
        { label: 'Listed on TripAdvisor', status: 'missing', detail: 'Three rivals are quoted from it. You are not on it.' },
        { label: 'Mentioned by local food writers', status: 'warn', detail: 'One food blog names you. Rivals appear on five.' },
      ],
      reputation: [
        { label: 'Google reviews', value: '312', comparison: "Baba's Kitchen has 540" },
        { label: 'Average rating', value: '4.6 stars', comparison: 'Second best on your street' },
        { label: 'Reviews you have replied to', value: '68%', comparison: 'Better than most nearby' },
      ],
      plainSummary:
        'Your customers and your menu are working for you. The gap is the questions your website does not answer yet, and the two sources AI trusts where you are missing.',
    },
    connections: [
      {
        channel: 'website', label: 'Your website', status: 'connected',
        method: 'We publish pages directly through your CMS.',
        detail: 'Connected 3 Jun · ourteam is an editor on your Wix site.',
      },
      {
        channel: 'listings', label: 'Directories & listings', status: 'action_needed',
        method: 'We claim and manage listings like TripAdvisor on your behalf.',
        detail: 'We can set up TripAdvisor for you once you verify ownership with the code they send.',
      },
    ],
    actions: [
      {
        id: 'a-ny-1', title: 'Add a page for family and group dining', channel: 'website',
        body: 'People ask AI for family-friendly and large-group Peranakan spots. You have no page that answers them, so AI names Baba\'s Kitchen instead.',
        estLift: 6, lever: 'site', helps: ['ai', 'google'], effort: 'We draft it, you approve',
        owner: 'oura', draftReady: true, draftCount: 1, status: 'todo',
        steps: [
          'We write a "Family & group dining" page covering big tables, kids and set menus.',
          'You approve the draft below.',
          'We publish it and track whether AI starts naming you for family questions.',
        ],
        draftPreview:
          'Family & group dining at Nyonya Table\n\nRound tables for 8–12, a kids’ portion of our milder dishes, and shared set menus from RM45/head. Book the back room for birthdays and reunions. High chairs available; just ask when you reserve.',
      },
      {
        id: 'a-ny-2', title: 'Get listed on TripAdvisor', channel: 'listings',
        body: 'Three of your rivals are quoted by AI from TripAdvisor. You are not on it at all. This is your single biggest missing source.',
        estLift: 7, lever: 'sources', helps: ['ai'], effort: 'We set it up, you verify',
        owner: 'oura', draftReady: false, draftCount: null, status: 'todo',
        steps: [
          'We create and fill out your TripAdvisor listing with your menu, photos and hours.',
          'You verify ownership with the code they post to you.',
          'We watch for AI to start quoting you from TripAdvisor, the way it already quotes three of your rivals.',
        ],
      },
      {
        // The one task Google proves and the AI engines do not (#3880): minted
        // from a real search, `helps: ['google']` with no 'ai', and carrying
        // both of Google's readings so the drawer can state the move instead of
        // only promising one.
        id: 'a-ny-8', title: 'Write a page about your set lunch', channel: 'website',
        body: 'People search for a Peranakan set lunch in this area and land on a rival. You have one, but no page says so.',
        estLift: 5, lever: 'site', helps: ['google'], effort: 'We draft it, you approve',
        owner: 'oura', draftReady: false, draftCount: null, status: 'in_progress',
        source: { type: 'search', ref: 'peranakan set lunch' },
        before: { position: 36, clicks: 2, searches: 5226 },
        after: { position: 9, clicks: 41, searches: 5226 },
      },
      {
        id: 'a-ny-3', title: 'Say clearly that you take date-night and celebration bookings', channel: 'website',
        body: 'You show up for date-night on some engines but not others. A short page about occasions and private dining would help AI bring you up more often.',
        estLift: 4, lever: 'site', helps: ['ai'], effort: 'We draft it, you approve',
        owner: 'oura', draftReady: true, draftCount: 2, status: 'in_progress',
        steps: [
          'We write a short "occasions & private dining" page for date nights and celebrations.',
          'You approve the two drafts below.',
          'We publish and track your date-night questions across all five engines.',
        ],
        draftPreview:
          'Date night at Nyonya Table\n\nSoft lighting, a quiet corner for two, and a five-course sharing menu built for slow evenings.\n\n— — —\n\nCelebrations & private dining\n\nReserve the back room for anniversaries and birthdays. We’ll plate a candle dessert and hold the mic for a toast.',
      },
      {
        id: 'a-ny-4', title: 'Finish your Google menu', channel: 'google_business',
        body: 'Your Google menu is 60% filled. Completing it lets AI quote your signature dishes by name.',
        estLift: 3, lever: 'sources', helps: ['ai', 'google'], effort: 'We do it, you confirm the dishes',
        owner: 'oura', draftReady: false, draftCount: null, status: 'in_progress',
      },
      {
        id: 'a-ny-5', title: 'Add whether dishes are halal to your menu',
        body: 'People ask AI whether Peranakan places are halal. Your menu does not say, so AI stays silent about you for that question.',
        estLift: null, lever: 'site', helps: ['ai'], effort: '30 minutes',
        owner: 'client', draftReady: false, draftCount: null, status: 'todo',
      },
      {
        id: 'a-ny-6', title: 'Complete your Google Business menu',
        body: 'Added all signature dishes so AI can quote them.',
        estLift: 6, lever: 'sources', helps: ['ai', 'google'], effort: 'Done',
        owner: 'oura', draftReady: false, draftCount: null, status: 'done',
      },
      {
        id: 'a-ny-7', title: 'Fix inconsistent opening hours',
        body: 'Synced hours across Google, Apple and Bing.',
        estLift: 2, lever: 'sources', helps: ['ai', 'google'], effort: 'Done',
        owner: 'oura', draftReady: false, draftCount: null, status: 'done',
      },
    ],
    feed: [
      { id: 'f-ny-1', kind: 'gained', plain: 'ChatGPT now brings you up for "date night in Bukit Bintang".', at: '2026-07-05' },
      { id: 'f-ny-2', kind: 'lost', plain: "Baba's Kitchen overtook you on Perplexity for nyonya food.", at: '2026-07-03' },
      { id: 'f-ny-3', kind: 'completed', plain: 'We finished adding your full menu to Google.', at: '2026-06-30' },
      { id: 'f-ny-4', kind: 'gained', plain: 'You moved from fourth to third on Google for Peranakan food.', at: '2026-06-24' },
      { id: 'f-ny-5', kind: 'drifted', plain: 'Your opening hours disagreed across Google and Apple. We fixed it.', at: '2026-06-18' },
    ],
    history: [
      { month: '2026-05', total: 41, level: 2, projected: false, note: 'Baseline.' },
      { month: '2026-06', total: 44, level: 2, projected: false, note: 'Google menu completed.' },
      { month: '2026-07', total: 58, level: 3, projected: false, note: 'Named more often after menu and hours fixes.' },
      { month: '2026-08', total: null, level: null, projected: true, note: 'With the family page and TripAdvisor, restaurants like yours typically reach the mid 60s.' },
      { month: '2026-09', total: null, level: null, projected: true, note: 'The low 70s is common once AI trusts a second source.' },
    ],
  },
};
